
import React from 'react';
import { TabsList, TabsTrigger } from '@/components/ui/tabs';
import { BarChart2, FileText, Lightbulb, Share2, Sparkles } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

interface AnalysisTabNavigationProps {
  isMobile: boolean;
}

export const AnalysisTabNavigation: React.FC<AnalysisTabNavigationProps> = ({ isMobile }) => {
  return (
    <TabsList className="grid w-full grid-cols-5 mb-4 bg-gradient-to-r from-teal-500/5 to-emerald-500/5 border border-teal-500/10 rounded-lg p-1 gap-1">
      <TabsTrigger 
        value="scores"
        className="flex items-center justify-center gap-1 transition-all data-[state=active]:bg-gradient-to-r data-[state=active]:from-teal-500 data-[state=active]:to-emerald-500 data-[state=active]:text-white rounded-md"
        aria-label="Performance Scores"
      >
        <BarChart2 className="h-4 w-4" />
        {!isMobile && <span>Scores</span>}
        {isMobile && <span className="sr-only">Performance Scores</span>}
      </TabsTrigger>
      <TabsTrigger 
        value="recommendations"
        className="flex items-center justify-center gap-1 transition-all data-[state=active]:bg-gradient-to-r data-[state=active]:from-amber-500 data-[state=active]:to-orange-500 data-[state=active]:text-white rounded-md"
        aria-label="Actionable Fixes"
      >
        <Lightbulb className="h-4 w-4" />
        {!isMobile && <span>Fixes</span>}
        {isMobile && <span className="sr-only">Actionable Fixes</span>}
      </TabsTrigger>
      
      <TabsTrigger 
        value="shareability"
        className="flex items-center justify-center gap-1 transition-all data-[state=active]:bg-gradient-to-r data-[state=active]:from-blue-500 data-[state=active]:to-indigo-500 data-[state=active]:text-white rounded-md"
        aria-label="Shareability"
      >
        <Share2 className="h-4 w-4" />
        {!isMobile && <span>Share</span>}
        {isMobile && <span className="sr-only">Shareability</span>}
      </TabsTrigger>
      
      <TabsTrigger 
        value="bonusInsights"
        className="flex items-center justify-center gap-1 transition-all data-[state=active]:bg-gradient-to-r data-[state=active]:from-purple-500 data-[state=active]:to-pink-500 data-[state=active]:text-white rounded-md"
        aria-label="Creative Insights"
      >
        <Sparkles className="h-4 w-4" />
        {!isMobile && <span>Insights</span>}
        {isMobile && <span className="sr-only">Creative Insights</span>}
      </TabsTrigger>
      
      <TabsTrigger 
        value="fullReport"
        className="flex items-center justify-center gap-1 transition-all data-[state=active]:bg-gradient-to-r data-[state=active]:from-gray-600 data-[state=active]:to-gray-700 data-[state=active]:text-white rounded-md"
        aria-label="Full Report"
      >
        <FileText className="h-4 w-4" />
        {!isMobile && <span>Report</span>}
        {isMobile && <span className="sr-only">Full Report</span>}
      </TabsTrigger>
    </TabsList>
  );
};
